import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoButtonModule, PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule, PoPageDynamicTableModule } from '@po-ui/ng-templates';
import { ProcessamentoFaturasComponent } from './processamento-faturas.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicTableModule,
    PoPageDynamicEditModule,
    PoButtonModule
  ],
  declarations: [ProcessamentoFaturasComponent]
})
export class ProcessamentoFaturasModule { }